<template>
  <div class="wrapper">
    <el-dialog
      title="银行支付"
      :visible.sync="dialogVisible"
      width="600px"
      append-to-body
      :before-close="close"
      :close-on-click-modal="false"
    >
      <el-form
        ref="formData"
        :model="formData"
        :rules="rules"
        label-width="120px"
      >
        <el-form-item label="运费金额">
          <el-input v-model="row.deliveryFeeDeserved" :disabled="true" />
        </el-form-item>
        <el-form-item label="已预付金额">
          <el-input v-model="row.payAmount" :disabled="true" />
        </el-form-item>
        <el-form-item label="托运人已付">
          <el-input v-model="row.allotTaxAmount" :disabled="true" />
        </el-form-item>
        <el-form-item label="已预付油点">
          <el-input v-model="row.payOil" :disabled="true" />
        </el-form-item>
        <!--        <el-form-item label="可分配油点" prop="amount">-->
        <!--          <el-input v-model="formData.amount" disabled />-->
        <!--        </el-form-item>-->
        <el-form-item label="平台付款银行">
          <el-input v-model="formData.platformBank" disabled />
        </el-form-item>
        <el-form-item label="平台开户企业">
          <el-input v-model="formData.platformCompanyName" disabled />
        </el-form-item>
        <el-form-item label="平台公户账号">
          <el-input v-model="formData.platformAccount" disabled />
        </el-form-item>
        <el-form-item label="收款方银行">
          <el-input v-model="backData.bankName" disabled />
        </el-form-item>
        <el-form-item label="收款方名称">
          <el-input v-model="backData.name" disabled />
        </el-form-item>
        <el-form-item label="预付运费" prop="totalAmount">
          <el-input
            v-model="formData.totalAmount"
            step="0.01"
            min="0"
            @input="
              value =>
                formFormatter.isFloor2(value, oldValue, formData, 'totalAmount')
            "
          />
        </el-form-item>
        <el-row :gutter="10">
          <el-col :span="20">
            <el-form-item label="获取验证码" prop="verifyCode">
              <el-input
                v-model="formData.verifyCode"
                maxlength="20"
                placeholder="请输入验证码"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <div class="grid-content bg-purple-light">
              <el-button
                v-show="showCode"
                type="primary"
                round
                size="small"
                :disabled="!formData.totalAmount"
                @click="getCode"
                >获取验证码</el-button
              >
              <span
                v-show="!showCode"
                style="height: 40px;line-height: 40px;display: block;padding-left: 5px;"
                >{{ count }}</span
              >
            </div>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button
            type="primary"
            :disabled="!formData.totalAmount"
            @click="submit"
            >确认打款</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  bankPartyCode,
  centralPrepayment,
  loginUserDefaultHousehold
} from "@/api/transport";
import { sendCentralCode } from "@/api/InternetBanking";
export default {
  props: {
    parentData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      showCode: true,
      tableData: [],
      formData: {
        codes: [],
        orderNo: "",
        createdBy: "",
        payReceiptImg: "",
        createdTime: "",
        platformBank: "",
        platformCompanyName: "",
        platformAccount: ""
      },
      row: {},
      backData: {
        platformBank: "",
        platformCompanyName: "",
        platformAccount: ""
      },
      rules: {
        totalAmount: [
          { required: true, message: "请输入待打款金额", trigger: "blur" },
          {
            validator(rule, value, callback) {
              value <= 0
                ? callback(new Error("请输入大于0的金额"))
                : callback();
            }
          }
        ],
        verifyCode: [
          { required: true, message: "请输入验证码", trigger: "blur" }
        ]
      },
      count: 0
    };
  },
  created() {},
  methods: {
    show(row) {
      this.row = row;
      this.formData = Object.assign({}, this.parentData);
      this.formData.prepaidAmount = this.formData.totalAmount;
      this.findList();
    },
    // 获取/查询 列表
    async findList() {
      if (this.parentData) {
        const rLoading = this.openLoading();
        let response_l = await loginUserDefaultHousehold({
          branchCode: this.parentData.branchCode,
          type: 0
        });
        if (!response_l.data) {
          rLoading.close();
          this.$message.error("当前机构没有默认公户无法打款");
          return;
        }
        // let response = await bankPartyCode(this.parentData.createdBy)
        let bankParams = {
          partyCode: this.parentData.payeeCode,
          orderDetailCodes: this.parentData.orderDetailCode
        };
        let response = await bankPartyCode(bankParams);
        rLoading.close();
        if (!response.data) {
          this.$message.error("当前实际承运人没有绑定银行卡无法打款！");
          return;
        }
        this.dialogVisible = true;
        this.backData = response.data;
        this.formData.platformBank = response_l.data.bankName;
        this.formData.platformCompanyName = response_l.data.companyName;
        this.formData.platformAccount = response_l.data.bankNum;
        this.formData.payeePhone = this.backData.phone;
      } else {
        this.$message.error("没有选中打款实际承运人！");
        return;
      }
    },
    //获取验证码
    async getCode() {
      let form = {
        partyGroupCode: this.formData.branchCode,
        orderDetailNumber: this.formData.orderDetailNumber,
        type: "3",
        totalAmount: this.formData.totalAmount,
        orderDetailCode: this.parentData.orderDetailCode
      };
      const rLoading = this.openLoading();
      let response = await sendCentralCode(form);
      rLoading.close();
      this.$message.success(response.msg);
      this.updating = false;
      if (response.status == 0) {
        const TIME_COUNT = 60;
        if (!this.timer) {
          this.count = TIME_COUNT;
          this.showCode = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--;
            } else {
              this.showCode = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      }
    },
    // 提交
    submit() {
      this.$refs.formData.validate(async valid => {
        if (valid) {
          const rLoading = this.openLoading();
          let response = await centralPrepayment(this.formData);
          rLoading.close();
          this.$message.success(response.msg);
          this.$emit("onSuccess");
          this.updating = true;
          this.count = 0;
          this.dialogVisible = false;
        }
      });
    },
    // 关闭
    close() {
      this.$refs.formData.resetFields();
      this.dialogVisible = false;
    }
  }
};
</script>
